function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M26.0649 0H9.93443C4.45659 0 0 4.4568 0 9.93464V26.0651C0 31.5432 4.45659 35.9998 9.93443 35.9998H26.0649C31.5432 35.9998 35.9998 31.543 35.9998 26.0651V9.93464C36 4.4568 31.5432 0 26.0649 0ZM32.8059 26.0651C32.8059 29.782 29.782 32.8057 26.0651 32.8057H9.93443C6.2178 32.8059 3.19408 29.782 3.19408 26.0651V9.93464C3.19408 6.21801 6.2178 3.19408 9.93443 3.19408H26.0649C29.7818 3.19408 32.8057 6.21801 32.8057 9.93464V26.0651H32.8059Z",
  fill: "#4563CB"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.9993 8.72411C12.8843 8.72411 8.72305 12.8853 8.72305 18.0003C8.72305 23.1151 12.8843 27.2761 17.9993 27.2761C23.1143 27.2761 27.2755 23.1151 27.2755 18.0003C27.2755 12.8853 23.1143 8.72411 17.9993 8.72411ZM17.9993 24.0819C14.6457 24.0819 11.9171 21.3537 11.9171 18.0001C11.9171 14.6463 14.6455 11.918 17.9993 11.918C21.3531 11.918 24.0814 14.6463 24.0814 18.0001C24.0814 21.3537 21.3529 24.0819 17.9993 24.0819Z",
  fill: "#4563CB"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M27.6626 6.01562C27.0472 6.01562 26.4427 6.26476 26.0081 6.70129C25.5714 7.13568 25.3203 7.74043 25.3203 8.35795C25.3203 8.97355 25.5716 9.57808 26.0081 10.0146C26.4425 10.449 27.0472 10.7003 27.6626 10.7003C28.2802 10.7003 28.8828 10.449 29.3193 10.0146C29.7558 9.57808 30.005 8.97334 30.005 8.35795C30.005 7.74043 29.7558 7.13568 29.3193 6.70129C28.8849 6.26476 28.2802 6.01562 27.6626 6.01562Z",
  fill: "#4563CB"
});

var SvgIcoInsta = function SvgIcoInsta(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgIcoInsta, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ico_insta.d68539c0.svg";
export { ForwardRef as ReactComponent };